module.exports = __webpack_public_path__ + "static/media/nine.7caaa155.svg";